import { UserEntityInterface } from '@types';

export const findUsers = (
  data: any,
  criteria: string[],
  result: UserEntityInterface[] = []
): UserEntityInterface[] => {
  if (!data) {
    return [];
  }
  let users = [...result];
  const keys = Object.keys(data);
  for (const key of keys) {
    const field = data[key];
    if (field && typeof field === 'object') {
      users = [...users, ...findUsers(field, criteria)];
    } else if (criteria.includes(key)) {
      users.push(data.data ?? data);
    }
  }
  return users;
};
